import { useMutation } from "@tanstack/react-query";
import { useDispatch } from "react-redux";
import apiClient from "@/modules/request.module.v2";
import { notify } from "@/components/framework/notify";
import i18n from "@/i18n";
import { companyChanged, fetchUserCompanies } from "@/actions/company.actions";
import { fetchMenu } from "@/actions/menu.actions";

const useCompleteActiveCompanyAccount = ({ onSuccess, onError } = {}) => {
  const dispatch = useDispatch();

  return useMutation({
    mutationKey: ["completeActiveCompanyAccount"],
    mutationFn: (payload) => {
      return apiClient.post("/companies/active/complete", payload);
    },
    onSuccess: async (mutationResponse, variables, context) => {
      const company = mutationResponse?.data?.company;

      if (company) {
        dispatch(companyChanged(company));
      }

      await dispatch(fetchUserCompanies("me"));
      dispatch(fetchMenu("main"));

      onSuccess?.(mutationResponse, variables, context);
    },
    onError: (error, variables, context) => {
      const translationId = error?.response?.data?.translationId;

      notify("error", i18n.t(translationId || "generic.unknown_error"));

      onError?.(error, variables, context);
    },
  });
};

export { useCompleteActiveCompanyAccount };
